import { IState } from "../../../../../common";
import { SportModel } from "../../../model";
import { BFFGateway, EventsCountResponse, EventsCountByTagRequest } from "sb-resp-lib";
import { sportDictionary, liveStreamingMode } from "../../..";

type requestFactory = () => EventsCountByTagRequest;

export class LiveStreamingBaseRetriever {

    private readonly streamingId: string = "streaming";
    private readonly gateway: BFFGateway;
    private readonly dict: sportDictionary;
    private readonly refreshInterval: number;
    private readonly liveStreamingMode: liveStreamingMode;
    private isActive: boolean;
    private liveStreamingRefreshTimer: number;

    constructor(gateway: BFFGateway, dict: sportDictionary, refreshInterval: number, liveStreamingMode: liveStreamingMode) {
        this.gateway = gateway;
        this.dict = dict;
        this.refreshInterval = refreshInterval;
        this.liveStreamingMode = liveStreamingMode;
        this.isActive = false;
        this.liveStreamingRefreshTimer = -1;
    }

    activate() {
        this.isActive = true;
    }

    public async refresh(state: IState<SportModel>, requestFactory: requestFactory) {
        window.clearTimeout(this.liveStreamingRefreshTimer);
        return this.refreshInternal(state, requestFactory);
    }

    private async refreshInternal(state: IState<SportModel>, requestFactory: requestFactory) {
        const request = requestFactory();
        const response = await this.getCount(request);
        if (this.isActive) {
            response && this.updateLiveStreaming(state, response);
            if (this.refreshInterval > 0) {
                this.liveStreamingRefreshTimer = window.setTimeout(() => this.refreshInternal(state, requestFactory), this.refreshInterval);
            }
        }
    }

    private async getCount(request: EventsCountByTagRequest) {
        try {
            return await this.gateway.getCountByTag(request);
        }
        catch {
            return;
        }
    }

    private updateLiveStreaming(state: IState<SportModel>, data:EventsCountResponse) {
        const eventsCount = data.events ? data.events : 0;
        if (eventsCount > 0) {
            const liveStreamingItem = state.getItemById(this.streamingId);
            if (liveStreamingItem) {
                state.update(this.streamingId, {numberOfEvents: eventsCount});
            }
            else {
                state.add(this.getStreamingItem(eventsCount));
            }
        }
        else
        {
            state.remove(this.streamingId);
        }
    }

    private getStreamingItem(numberOfEvents: number)
    {
        return new SportModel({
            id: this.streamingId,
            name: this.dict.streaming,
            numberOfEvents,
            order: this.getStreamingItemOrder()
        }, "liveStream");
    }

    private getStreamingItemOrder() : number {
        switch (this.liveStreamingMode) {
            case liveStreamingMode.firstSelected:
            case liveStreamingMode.first: return -1;
            case liveStreamingMode.last: return 1000;
        }
    }

    deactivate() {
        this.isActive = false;
        window.clearTimeout(this.liveStreamingRefreshTimer);
    }
}